define('BookingEngine/app-Confirmation/main',['./settings', "util", '../app-General/dialog'], function (settings, util, dialog) {
    return {
        run: function () {
            var container = $(settings.container);

            if (container.length === 0) {
                window.log('Confirmation container not found. BookingEngine/app-Confirmation will not be available.');
                return;
            }

            function isNullUndefEmpty(variable) {
                return (variable === null || variable === undefined || variable === '');
            }

            window.log('Loading Confirmation');

            container.find(".btnItinerary").on("click", function (event) {
                event.preventDefault();
                dialog.showDialog(settings.getItinerary);
            });

            $(".btnTradeAgentDetails").on("click", function (e) {
                $("#remittance").show();
                $("#remittanceAdvice").show();

                $(".remittanceClose").on("click", function () {
                    $("#remittance").hide();
                    $("#remittanceAdvice").hide();
                });
            });

            //ADL call
            AdlAddUpdateItem("pageName", "travel|purchase|bookingconfirmation");

            function adlBookingConfirm() {
                var bookingId = $('#bookingID').text();
                AdlAddUpdateItem("bookingReference", bookingId);
                localStorage.setItem("bookingReference", bookingId);

                var paymentReturnStatus = $('#adobePaymentReturnStatus').text(),
                    bookingStatus = $('#adobeBookingStatus').text();

                AdlAddUpdateItem("paymentReturn", paymentReturnStatus);
                localStorage.setItem("paymentReturn", paymentReturnStatus);
                AdlAddUpdateItem("bookingStatus", bookingStatus);
                localStorage.setItem("bookingStatus", bookingStatus);

                util.satelliteTrack("virtualPageViewTBJ");

                //after the tracking call set previous page name to this value
                //set a timeout to prevent it getting set before it's been read
                //also add it to local storage so that a page change picks up the correct value
                setTimeout(function () {
                    var prevpage = localStorage.getItem("previousPageName");

                    if (!isNullUndefEmpty(prevpage)) {
                        AdlAddUpdateItem("previousPageName", localStorage.getItem("previousPageName"));
                    }

                    localStorage.setItem("previousPageName", "travel|purchase|bookingconfirmation");
                }, 999);
            };

            clearTimeout(VPVtimer);
            VPVtimer = setTimeout(adlBookingConfirm, 500);

            window.loadedModules("BookingEngine/app-Confirmation");
        }
    }
});

